<template>
  <Page :page-name="pageName" :table="table" :pagination="pagination" :search-bar="searchBar"
  v-loading="loading" element-loading-text="数据加载中" element-loading-background="rgba(255, 255, 255, 0.5)">

    <template slot="table-operate" slot-scope="{scope}">
      <el-button type="text"   @click="edit(scope)" :disabled="scope.applyStatus!=0">
        审批
      </el-button>
    </template>
    <template slot="applyStatus" slot-scope="{scope}">
      <span>
        {{ scope.applyStatus==0?'待审批': scope.applyStatus==1?'已完成':'已驳回'}}
      </span>
    </template>
    <Dialogs title="审批" :is-show-dialog="isShowPage" width="26%" @handleClick="handleClose" :enterEvent="clickPage">
      <div slot="content">
        <AccoutDetail
          ref="accountDetailRef"
          :row-form="rowData"
        />
      </div>
      <div slot="btns" slot-scope="{scope}">
        <el-button @click="cancel" type="default" style="margin-right: 10px;">取 消</el-button>
        <el-button @click="clickPage(-1)" type="danger" style="margin-right: 10px;">拒 绝</el-button>
        <el-button type="primary" @click="clickPage(1)" >通 过</el-button>
      </div>
    </Dialogs>

  </Page>
</template>

<script>
import Page from '@/components/Page2.vue'
import AccoutDetail from './accoutDetail'
import {getMemberApplyList, approval} from '@/api/charityMember'
import Dialogs from '@/components/page/Dialogs.vue'
import mixin from '@/utils/mixin'
import {isValidPhoneNumber} from '@/utils/index'

export default {
  name: 'Account',
  components: {
    AccoutDetail,
    Page,
    Dialogs
  },
  props: {
    applyStatus: [Number, String]
  },
  mixins: [mixin],
  data () {
    return {
      pageName: '青藤会员',
      table: {
        selection: false, // 是否开启选择框
        tableInfo: [{
          key: 'num',
          name: '序号',
          minWidth: 60
        }, {
          key: 'userId',
          name: 'ID',
          minWidth: 80
        }, {
          key: 'nickName',
          name: '昵称',
          minWidth: 60
        }, {
          key: 'phone',
          name: '电话',
          minWidth: 60
        }, {
          key: 'applyDate',
          name: '申请时间',
          minWidth: 80
        }, {
          key: 'applyStatus',
          name: '状态',
          minWidth: 80,
          type: 'custom'
        }],
        tableData: [],
        deleteItem: () => {}
      },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'nickName',
          label: '昵称',
          placeholder: '请输入'
        }, {
          type: 'input',
          prop: 'phone',
          label: '电话',
          placeholder: '请输入'
        },
        // {
        //   type: 'select',
        //   prop: 'applyStatus',
        //   label: '类型',
        //   options: [{
        //     label: '待审批',
        //     value: '0'
        //   }, {
        //     label: '已驳回',
        //     value: '-1'
        //   }, {
        //     label: '已通过',
        //     value: '1'
        //   }],
        //   placeholder: '请选择'
        // },
        {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: this.searchBarform
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      nickName: '',
      phone: '',
      roleNameData: [],
      loading: false,
      rowData: {}
    }
  },
  computed: {
    params () {
      return {
        current: this.pagination.currentPage,
        size: this.pagination.size,
        nickName: this.nickName,
        phone: this.phone,
        applyStatus: this.applyStatus
      }
    }
  },
  watch: {
    params () {
      this.getUserList()
    }
  },
  created () {
    this.getUserList()
  },
  methods: {
    getUserList () {
      const params = this.params
      this.loading = true
      getMemberApplyList(params).then(({success, data}) => {
        if (success) {
          const {records, total} = data
          this.pagination.total = total
          this.table.tableData = records
          this.table.tableData.forEach((item, idx) => {
            item.num = (this.pagination.currentPage - 1) * 10 + idx + 1
          })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    clickNewPage () {
      this.isShowPage = true
    },
    edit (row) {
      this.rowData = row
      this.isShowPage = true
      this.pageFlag = 2
    },
    cancel () {
      this.isShowPage = false
      this.rowData = null
    },
    clickPage (applyStatus) {
      if (this.pageFlag === 1) return
      const refForm = this.$refs.accountDetailRef.$refs.rowForm
      refForm.validate((valid) => {
        if (valid) {
          const {
              id
            } = this.rowData
          const params = {
            id,
            applyStatus
          }

          approval(params).then(({success}) => {
            if (success) {
              this.$message({
                type: 'success',
                message: `审批成功`
              })
              this.getUserList()
            }
            this.cancel()
          })
        }
      })
    },
    searchBarform (params) {
      console.log('params', params)
      this.ms && this.ms.close()
      const obj = {...this.params, ...params, nickName: params.nickName.trim()}
      const {nickName} = obj
      if ((nickName && nickName.length > 30)) {
        this.ms = this.$message({
          type: 'warning',
          message: '搜索的长度不能超过20字'
        })
        return
      }
      if (obj.phone && !isValidPhoneNumber(obj.phone)) {
        this.ms = this.$message({
          type: 'warning',
          message: '请输入正确的手机号'
        })
        return
      }
      this.nickName = obj.nickName
      this.phone = obj.phone
      this.pagination.currentPage = 1
    },
    clearParams () {
      this.nickName = ''
      this.phone = ''
    }
  }
}
</script>

